import * as React from 'react'

export default () => {
  return (
    <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 9.54464L10.2991 17.8437L26.1429 2" stroke="#26C36F" strokeWidth="4" />
    </svg>
  )
}
